import * as React from 'react';
import { useReporting } from '../../hooks/useReporting';
import { DatasetTotalResultEnum } from '../../@shared/Models/Reporting/ReportingResult';
import moment from 'moment';
import { Palette } from '../../@shared/palette';
import "react-datepicker/dist/react-datepicker.css";
import { ChartItem } from '../../hooks/useCharts';
import LineChartComponent from '../../components/LineChart';
import { ReportingProviderInstance } from '../../@shared/services/ReportingProvider';
import { ReportingWithIdModel } from '../../@shared/Models/Reporting/ReportingWithIdModel';


export type TabsContentMonitoringModelUsageProps = {
  schemaId: string;
}

const TabsContentMonitoringDataItemsCount = (props: TabsContentMonitoringModelUsageProps) => {
  const items = React.useMemo((): ChartItem[] => {
    return [
      { label: "Dataset items", color: Palette.btnPrimary, key: "dataset" },
      { label: "Test Dataset items", color: Palette.textColorWarning, key: "test" }
    ];
  }, []);

  const _reportingProviderInstance = React.useMemo(() => ReportingProviderInstance, []);

  const reportingHook = useReporting({
    onLoadData: async (input) => {
      return await _reportingProviderInstance.dataset(input as ReportingWithIdModel);
    }
  });

  React.useEffect(() => {
    reportingHook.onLoadDataset(props.schemaId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.schemaId, reportingHook.baseRequest]);


  const data = React.useMemo(() => {
    if (!reportingHook.dataResults?.data || reportingHook.isLoadingDataset) {
      return [];
    }

    return reportingHook.dataResults.data[DatasetTotalResultEnum.DataLength].map((item, index) => {
      return {
        name: reportingHook.baseRequest.granularityInMinutes >= 1440 ? moment(item.date).format("MMM DD") : moment(item.date).format("MMM DD H:mm"),
        dataset: item.value,
        test: reportingHook.dataResults!.data![DatasetTotalResultEnum.DataLengthTest][index].value,
      };
    });
  }, [reportingHook.baseRequest.granularityInMinutes, reportingHook.dataResults, reportingHook.isLoadingDataset]);

  return <LineChartComponent {...reportingHook} items={items} data={data} title='Items count' />
}

export default TabsContentMonitoringDataItemsCount;
